"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
/**
 * Notification Types (the keys as stored in the notifications DB)
 * @alpha
 */
var NotificationType;
(function (NotificationType) {
    NotificationType["BADGE_GRANTED"] = "badge_granted";
    NotificationType["BID_ACCEPTED"] = "bid_accepted";
    NotificationType["BID_RECEIVED"] = "bid_received";
    NotificationType["EVENTS_STARTED"] = "events_started";
    NotificationType["EVENTS_STARTS_SOON"] = "events_starts_soon";
    NotificationType["GOVERNANCE_ANNOUNCEMENT"] = "governance_announcement";
    NotificationType["GOVERNANCE_AUTHORED_PROPOSAL_FINISHED"] = "governance_authored_proposal_finished";
    NotificationType["GOVERNANCE_COAUTHOR_REQUESTED"] = "governance_coauthor_requested";
    NotificationType["GOVERNANCE_CLIFF_ENDED"] = "governance_cliff_ended";
    NotificationType["GOVERNANCE_NEW_COMMENT_ON_PROJECT_UPDATE"] = "governance_new_comment_on_project_update";
    NotificationType["GOVERNANCE_NEW_COMMENT_ON_PROPOSAL"] = "governance_new_comment_on_proposal";
    NotificationType["GOVERNANCE_PROPOSAL_ENACTED"] = "governance_proposal_enacted";
    NotificationType["GOVERNANCE_VOTING_ENDED_VOTER"] = "governance_voting_ended_voter";
    NotificationType["GOVERNANCE_PITCH_PASSED"] = "governance_pitch_passed";
    NotificationType["GOVERNANCE_TENDER_PASSED"] = "governance_tender_passed";
    NotificationType["GOVERNANCE_WHALE_VOTE"] = "governance_whale_vote";
    NotificationType["GOVERNANCE_VOTED_ON_BEHALF"] = "governance_voted_on_behalf";
    NotificationType["ITEM_SOLD"] = "item_sold";
    NotificationType["ITEM_PUBLISHED"] = "item_published";
    NotificationType["LAND_RENTAL_ENDED"] = "rental_ended";
    NotificationType["LAND_RENTED"] = "rental_started";
    NotificationType["REWARD_ASSIGNED"] = "reward_assignment";
    NotificationType["REWARD_CAMPAIGN_OUT_OF_FUNDS"] = "reward_campaign_out_of_funds";
    NotificationType["REWARD_CAMPAIGN_GAS_PRICE_HIGHER_THAN_EXPECTED"] = "reward_campaign_gas_price_higher_than_expected";
    NotificationType["REWARD_CAMPAIGN_OUT_OF_STOCK"] = "reward_campaign_out_of_stock";
    NotificationType["REWARD_DELAYED"] = "reward_delayed";
    NotificationType["REWARD_IN_PROGRESS"] = "reward_in_progress";
    NotificationType["ROYALTIES_EARNED"] = "royalties_earned";
    NotificationType["WORLDS_ACCESS_RESTORED"] = "worlds_access_restored";
    NotificationType["WORLDS_ACCESS_RESTRICTED"] = "worlds_access_restricted";
    NotificationType["WORLDS_MISSING_RESOURCES"] = "worlds_missing_resources";
    NotificationType["WORLDS_PERMISSION_GRANTED"] = "worlds_permission_granted";
    NotificationType["WORLDS_PERMISSION_REVOKED"] = "worlds_permission_revoked";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
//# sourceMappingURL=notifications.js.map